import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface ConnectedAccountsLimit {
  allowed: boolean;
  unlimited: boolean;
  current_count: number;
  limit: number;
  remaining: number;
}

export const useConnectedAccountsLimit = () => {
  const { data, isLoading, error, refetch } = useQuery<ConnectedAccountsLimit>({
    queryKey: ['connectedAccountsLimit'],
    queryFn: async () => {
      const response = await api.get('/social/limits/connected-accounts');
      return response.data;
    },
    staleTime: 30000, // Cache for 30 seconds
    retry: 1,
  });

  return {
    limit: data,
    isLoading,
    error,
    refetch,
    canConnect: data?.allowed ?? true,
    isAtLimit: data ? !data.allowed : false,
    currentCount: data?.current_count ?? 0,
    maxLimit: data?.limit ?? -1,
    remaining: data?.remaining ?? -1,
    isUnlimited: data?.unlimited ?? false,
  };
};
